import { render } from "./Certificate.vue?vue&type=template&id=24cbf3a9"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"

import "./Certificate.vue?vue&type=style&index=0&id=24cbf3a9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__